import { useMemo } from 'react';
import { store }   from 'index'
import { colors }  from 'utils/colors';

const useStyle = (
    showImage:       boolean,
    showHomepageApp: boolean,
    showZoomMessage: boolean
) => {

  const state          = store.getState();
  const sizeState      = state.size;
  const manualNavState = state.manualNav

  const [containerStyle, imageStyle, userNameStyle, buttonStyle, textStyle] = useMemo(() => {

    const { size, navBarSize } = sizeState;

    const smallScreen = (size[1] < 650);

    return[
      {
        width:     showImage ? size[0]/2 : size[0],
        height:    showHomepageApp ? size[1] - navBarSize : showZoomMessage ? size[1] - 200 : showImage ? 300 : size[1] - navBarSize,
        right:     size[0] > 1100 ? '10vw' : 0,
        marginTop: navBarSize
      },
      {
       top:    navBarSize,
       height: size[1] - navBarSize,
      },
      {
        flexFlow:        !showHomepageApp ? 'column' : 'row',
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
        fontSize:        smallScreen ? 20 : !showHomepageApp ? 28 : 24,
        marginBottom:    smallScreen ? 5 : 20,
        overflow:        'hidden'
      },
      {
        height:   smallScreen ? 35 : undefined,
        fontSize: smallScreen ? 18 : undefined,
        border:   manualNavState.manualOn && manualNavState.manualVal === "goToContent" ? `4px solid ${ colors.blue }` : undefined
      },
      {
        fontSize: smallScreen ? 17 : undefined
      }
    ]
  },[sizeState, showHomepageApp, showImage, showZoomMessage, manualNavState])


  return { containerStyle, imageStyle, userNameStyle, buttonStyle, textStyle }

}

export default useStyle;
